module.exports = "/_next/static/images/profile-monotone-25e9c8867f6d7cedee4dd3fc25be31c9.svg";